import styled from "styled-components";

export const Button = ({type = 'primary', text, prefix, sufix, width='auto', onClick, disabled=false, ...restProps}) => {

    return (
        <StyledButton
            onClick={onClick}
            $type={type}
            $width={width}
            {...restProps}
            className={type}
            disabled={disabled}
        > 
            {prefix}
            {text}
            {sufix}
        </StyledButton>
    )
}

const StyledButton = styled.button`
    
    border-radius: ${({theme}) => theme.cornerRadius.md};
    height: 32px;
    padding: 0 ${({theme}) => theme.spacing.lg};
    gap: ${({theme}) => theme.spacing.md};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    cursor: pointer;
    width: ${({$width}) => $width === 'lg' ? '200px' : $width === 'md' ? '150px' : $width === 'sm' ? '80px' : $width === 'fit' ? 'fit-content' : 'auto'};
    
    &.primary
    {
        background: ${({theme}) => theme.colors.neutralSecondaryForeground};
        color: ${({theme}) => theme.colors.neutralPrimaryBackground};
        border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    }

    &.secondary
    {
        background: ${({theme}) => theme.colors.neutralInputBackground};
        color: ${({theme}) => theme.colors.neutralSecondaryForeground};
        border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    }

    &.tertiary
    {
        background: transparent;
        color: ${({theme}) => theme.colors.mutedForeground};
        border: none;
        border-bottom: 2px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        border-radius: 0;
        transition-duration: 110ms;

        &:hover
        {
            color: ${({theme}) => theme.colors.neutralSecondaryForeground};
            border-bottom: 2px solid ${({theme}) => theme.colors.neutralSecondaryForeground};
        }

    }

    &:disabled
    {
        cursor: not-allowed;

        &.primary
        {
            background: ${({theme}) => theme.colors.mutedForeground};
        }

        &.secondary
        {
            color: ${({theme}) => theme.colors.mutedForeground};
        }

        &.tertiary
        {
            color: ${({theme}) => theme.colors.mutedForeground};

            &:hover
            {
                color: ${({theme}) => theme.colors.mutedForeground};
                border-bottom: 2px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            }
        }

    }
    

    .icon
    {
        font-size: ${({theme}) => theme.iconSize.sm};;
    }
`